import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

interface ActionItem {
  actionItem: string;
  actionItemAssignee: string;
  actionItemDueDate: string;
}

@Component({
  selector: 'app-checklist-actions',
  templateUrl: './checklist-actions.component.html',
  styleUrls: ['./checklist-actions.component.scss']
})
export class ChecklistActionsComponent implements OnInit {
  actionItemsDataSource = new MatTableDataSource<ActionItem>([]);
  displayedColumns: string[] = ['actionItem', 'actionItemAssignee', 'actionItemDueDate'];
  checklists:any[]=[];
  @ViewChild(MatSort) sort: MatSort;

  constructor(public dialogref: MatDialogRef<ChecklistActionsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,) {
      this.checklists = dialogData['data'];
     }

  ngOnInit(): void {
    if(this.checklists.length>0){
      this.extractActionItems();
    }
  }

  ngAfterViewInit() {
    this.actionItemsDataSource.sort = this.sort;
  }

  extractActionItems() {
    const actionItems: ActionItem[] = [];

    this.checklists.forEach(item => {
      if (item.action_items) {
        item.action_items.forEach(actionItem => {
          actionItems.push(actionItem);
        });
      }
    });

    this.actionItemsDataSource.data = actionItems;
  }

  close(isSuccess?: boolean) {
    this.dialogref.close(isSuccess);
  }

}
